module.exports = __webpack_public_path__ + "static/media/48364710_2308815565860288_4860445331596247040_o-thumb.48c88f3f.jpg";